import { globalEntitlements } from '../utils/globalEntitlements';

export const NY_PUBLICATION_CONFIG = {
  hero: {
    buyBox: [{
      bulletPoints: [
        { title: 'productPage.nyPublication.buyBox.bulletPoint1' },
        { title: 'productPage.nyPublication.buyBox.bulletPoint2' },
        { title: 'productPage.nyPublication.buyBox.bulletPoint3' }
      ],
      productName: 'productPage.nyPublication.buyBox.productName',
      interactService: {
        ctaType: 'internalCheckout',
        service: 'ny_publication'
      }
    }],
    headerPicture: {
      src: '/s2/raster/package-warehouse-team.png',
      alt: 'productPage.nyPublication.heroPicture.altText'
    },
    headline: 'productPage.nyPublication.page.headline',
    partnerLogo: {},
    partnerReviewBlanks: [],
    pill: {
      text: 'productPage.nyPublication.page.headlinePill',
      bgcolor: 'background.red.light'
    },
    subheader: 'productPage.nyPublication.page.subheader'
  },
  benefit: {
    title: 'productPage.nyPublication.valueProp.title',
    items: [
      {
        icon: '/s2/material-icons/gppgoodrounded.svg',
        title: 'productPage.nyPublication.valueProp.propTitle1',
        description: 'productPage.nyPublication.valueProp.shortCopy1'
      },
      {
        icon: '/s2/material-icons/hourglasstoprounded.svg ',
        title: 'productPage.nyPublication.valueProp.propTitle2',
        description: 'productPage.nyPublication.valueProp.shortCopy2'
      },
      {
        icon: '/s2/material-icons/attachmoneyrounded.svg ',
        title: 'productPage.nyPublication.valueProp.propTitle3',
        description: 'productPage.nyPublication.valueProp.shortCopy3'
      }
    ]
  },
  highlight: {
    icon: '/s2/material-icons/checkrounded.svg',
    title: 'productPage.nyPublication.topFeature.title',
    subheader: 'productPage.nyPublication.topFeature.subheader',
    image: '/s2/raster/focused-laptop-professional.png',
    alt: 'productPage.nyPublication.topFeature.altText'
  },
  howItWorks: {
    title: 'productPage.nyPublication.howItWorks.title',
    items: [
      {
        title: 'productPage.nyPublication.howItWorks.step1',
        description: 'productPage.nyPublication.howItWorks.shortDescription1'
      },
      {
        title: 'productPage.nyPublication.howItWorks.step2',
        description: 'productPage.nyPublication.howItWorks.shortDescription2'
      },
      {
        title: 'productPage.nyPublication.howItWorks.step3',
        description: 'productPage.nyPublication.howItWorks.shortDescription3'
      },
      {
        title: 'productPage.nyPublication.howItWorks.step4',
        description: 'productPage.nyPublication.howItWorks.shortDescription4'
      },
      {
        title: 'productPage.nyPublication.howItWorks.step5',
        description: 'productPage.nyPublication.howItWorks.shortDescription5'
      }
    ],
    image: '/s2/raster/fashion-checks-office.png',
    alt: 'productPage.nyPublication.howItWorks.altText',
    hasNumber: true,
    hasDivider: false,
    hasMobileImage: true
  },
  faqs: {
    title: 'productPage.nyPublication.frequentlyAskedQuestions.title',
    items: [
      {
        question: 'productPage.nyPublication.frequentlyAskedQuestions.faq1',
        answer: 'productPage.nyPublication.frequentlyAskedQuestions.faqAnswer1'
      },
      {
        question: 'productPage.nyPublication.frequentlyAskedQuestions.faq2',
        answer: 'productPage.nyPublication.frequentlyAskedQuestions.faqAnswer2'
      },
      {
        question: 'productPage.nyPublication.frequentlyAskedQuestions.faq3',
        answer: 'productPage.nyPublication.frequentlyAskedQuestions.faqAnswer3'
      },
      {
        question: 'productPage.nyPublication.frequentlyAskedQuestions.faq4',
        answer: 'productPage.nyPublication.frequentlyAskedQuestions.faqAnswer4'
      }
    ]
  },
  assistance: {
    title: 'productPage.nyPublication.needAssistance.title',
    getInTouch: 'productPage.nyPublication.needAssistance.getInTouch',
    actions: 'productPage.nyPublication.needAssistance.actions'
  },
  getBuyButtonConfig: globalEntitlements({ ctaText: 'productPage.nyPublication.buyBox.buttonLabel' })
    .formedByZb()
    .businessFormed()
    .jurisdictionIs('NY')
    .currentProductNotPurchased()
    .build()
};
